import { getField, updateField } from 'vuex-map-fields';
import SessionApi from '../backend/SessionApi';
import axios from '../backend/axios';
import router from '../router';
import { assignHelper } from './helpers';

export default {
  namespaced: true,
  state: {
    student: {},
    form: {
      email: '',
      password: '',
      currentPassword: '',
      chosen_area_of_study_id: undefined,
      chosen_faculty_id: undefined,
      chosen_university_id: undefined,
      internship_ids: [],
      title: undefined,
      lastname: undefined,
      firstname: undefined,
      birth_date: '',
      student_number: undefined,
      address: undefined,
      address_2: undefined,
      postal_code: undefined,
      city: undefined,
      mobile_phone_number: undefined,
      parent_title: undefined,
      parent_lastname: undefined,
      parent_address: undefined,
      parent_city: undefined,
      parent_postal_code: undefined,
      parent_email: undefined,
      parent_mobile_phone_number: undefined,
      session_id: undefined,
      minor: undefined,
      major: undefined,
      school_level: undefined,
      school_name: undefined,
      school_city: undefined,
      spe_1_1ere: undefined,
      spe_2_1ere: undefined,
      spe_3_1ere: undefined,
      average_grade_1ere: undefined,
      spe_1_grade_1ere: undefined,
      spe_2_grade_1ere: undefined,
      spe_3_grade_1ere: undefined,
      appreciation_1ere: undefined,
      spe_1_terminale: undefined,
      spe_2_terminale: undefined,
      spe_3_terminale: undefined,
      average_grade_terminale: undefined,
      spe_1_grade_terminale: undefined,
      spe_2_grade_terminale: undefined,
      spe_3_grade_terminale: undefined,
      appreciation_terminale: undefined,
    },
  },
  mutations: {
    setStudent: assignHelper('student'),
    resetFormPassword(state) {
      state.form.password = '';
      state.form.currentPassword = '';
    },
    updateField,
  },
  actions: {
    async signOut({ commit }) {
      await SessionApi.signOut();
      commit('setStudent', {});
      delete localStorage.authorization;
      axios.defaults.headers.authorization = null;
      if (router.currentRoute.path !== '/connexion') {
        router.push('/connexion');
      }
    },
    async signUp({ state }) {
      const response = await SessionApi.signUp(state.form);
      localStorage.authorization = response.headers.authorization;
      axios.defaults.headers.authorization = response.headers.authorization;
      return response;
    },
    async signIn({ state, dispatch }) {
      delete localStorage.authorization;
      axios.defaults.headers.authorization = null;
      const response = await SessionApi
        .signIn({ email: state.form.email, password: state.form.password });
      localStorage.authorization = response.headers.authorization;
      axios.defaults.headers.authorization = response.headers.authorization;
      dispatch('fetchMe');
      return response;
    },
    async fetchMe({ commit }) {
      const response = await SessionApi.me();
      commit('setStudent', response.data);
    },
    async askForPasswordReset({ state }) {
      const response = await SessionApi.askForPasswordReset({ email: state.form.email });
      return response;
    },
    async resetPassword({ commit, state }, { token }) {
      await SessionApi.resetPassword({ password: state.form.password, token });
      commit('resetFormPassword');
    },
    async changePassword({ state, commit }) {
      try {
        const response = await SessionApi.changePassword({
          password: state.form.password,
          currentPassword: state.form.currentPassword,
        });
        commit('resetFormPassword');
        commit('setAlert', {
          text: 'Votre mot de passe a été modifié',
          color: 'success',
          show: true,
        }, { root: true });
        return response;
      } catch (e) {
        commit('setAlert', {
          text: 'Une erreur s\'est produite',
          color: 'error',
          show: true,
        }, { root: true });
        return e;
      }
    },
    checkSignIn({ commit }) {
      SessionApi.me().then((response) => {
        commit('setStudent', response.data);
      });
    },
    resendConfirmationLink({ state }) {
      return SessionApi.resendConfirmationLink({ email: state.form.email });
    },
    uploadPicture({ commit }, picture) {
      SessionApi.uploadPicture(picture).then((response) => {
        commit('setStudent', response.data);
      });
    },
  },
  getters: {
    getField,
    connected: (state) => !!state.student.id,
  },
};
